module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-upload"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Álbum "), (_vm.dataUpload.title) ? _c('span', [_vm._v("- " + _vm._s(_vm.dataUpload.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "portlet light m-t-24"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm font-grey-cascade",
    attrs: {
      "to": "/gallery"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Voltar")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nome do álbum:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataUpload.title),
      expression: "dataUpload.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o nome do álbum"
    },
    domProps: {
      "value": (_vm.dataUpload.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataUpload, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Descrição do álbum:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataUpload.description),
      expression: "dataUpload.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite a descrição do álbum"
    },
    domProps: {
      "value": (_vm.dataUpload.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataUpload, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "assign-photo"
    }
  }, [_c('h5', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "m-t-20"
  }, [_vm._v("A quem você deseja atribuir o álbum?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Selecione:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.viewersGalleryType),
      expression: "viewersGalleryType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "viewersGallery",
      "disabled": _vm.album.id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.viewersGalleryType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.ENUM.viewersGalleryType), function(value, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(value))])
  }))]), _vm._v(" "), (_vm.viewersGalleryType == 'SCHOOL_CLASS') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('class-list', {
    attrs: {
      "multiple": true,
      "label": 'Turmas:',
      "context": 'gallery',
      "disabled": _vm.album.id ? true : false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.viewersGalleryType == 'STUDENT') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('class-list', {
    attrs: {
      "label": 'Turma:',
      "multiple": false,
      "context": 'gallery',
      "disabled": _vm.album.id ? true : false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.viewersGalleryType == 'STUDENT') ? _c('students', {
    class: 'col-md-4',
    attrs: {
      "context": 'gallery',
      "imglist": false,
      "disabled": _vm.album.id ? true : false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!(_vm.album.id)) ? _c('button', {
    staticClass: "btn yellow-gold m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createAlbum(_vm.dataUpload)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Criar álbum")])]) : _vm._e(), _vm._v(" "), (_vm.album.id) ? _c('button', {
    staticClass: "btn yellow-gold m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createAlbum(_vm.dataUpload)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editar álbum")])]) : _vm._e()]), _vm._v(" "), (_vm.album.id) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.album.status == 'APPROVED') ? _c('button', {
    staticClass: "btn red m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.unpublish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar todas as fotos")])]) : _vm._e(), _vm._v(" "), (_vm.album.status != 'APPROVED') ? _c('button', {
    staticClass: "btn green-jungle m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.publish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar todas as fotos")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body m-t-24"
  }, [(_vm.album.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": ("/api/v1/gallery/user/" + (_vm.getLoggedUser.id)),
      "data": _vm.dataUploadStringify(),
      "on-success": _vm.upload,
      "name": "files",
      "multiple": "",
      "accept": "image/*"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v("Arraste ou "), _c('em', [_vm._v("clique para adicionar imagens")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Recomendamos que sejam utilizadas imagens menores que 500kb para que não haja lentidão no carregamento.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 pull-left"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Fotos")])])]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn green-jungle m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar fotos selecionadas")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn red m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unpublishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar fotos selecionadas")])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('a', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade",
    on: {
      "click": _vm.selectAllPhotos
    }
  }, [_vm._v("Selecionar todas as fotos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('a', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade",
    on: {
      "click": _vm.unselectAllPhotos
    }
  }, [_vm._v("Remover seleção das fotos")])])]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "row",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".item"
    }
  }, _vm._l((_vm.album.photos), function(photo, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "col-md-6 card item"
    }, [_c('card', {
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 mt-element-ribbon m-b-0"
    }, [(!photo.publishedDateTime) ? _c('small', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "ribbon ribbon-color-danger"
    }, [_vm._v("NÃO PUBLICADA")]) : _vm._e(), _vm._v(" "), (photo.publishedDateTime) ? _c('small', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "ribbon ribbon-color-success"
    }, [_vm._v("Publicada às " + _vm._s(_vm._f("date")(photo.publishedDateTime, "HH:mm - DD/MM/YYYY")))]) : _vm._e(), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "row p-15"
    }, [_c('div', {
      staticClass: "col-md-1 form-group"
    }, [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-single mt-checkbox-outline"
    }, [_c('input', {
      staticClass: "checkboxes",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isChecked(photo.id)
      },
      on: {
        "click": function($event) {
          _vm.selectPhotos($event, photo)
        }
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('a', {
      attrs: {
        "href": photo.fileURL
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": photo.thumbnailURL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7 form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (photo.title),
        expression: "photo.title"
      }],
      staticClass: "form-control m-b-10",
      attrs: {
        "type": "text",
        "placeholder": "Digite o título da foto"
      },
      domProps: {
        "value": (photo.title)
      },
      on: {
        "change": function($event) {
          _vm.changeInfoPhoto(photo.id, photo.title, photo.description)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(photo, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (photo.description),
        expression: "photo.description"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Digite a descrição da foto"
      },
      domProps: {
        "value": (photo.description)
      },
      on: {
        "change": function($event) {
          _vm.changeInfoPhoto(photo.id, photo.title, photo.description)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(photo, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('a', {
      attrs: {
        "title": "Excluir foto"
      },
      on: {
        "click": function($event) {
          _vm.deletePhoto(photo.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash font-red",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row m-t-25"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn green-jungle m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar fotos selecionadas")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn red m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unpublishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar fotos selecionadas")])])])]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 pull-rigth"
  }, [(_vm.album.status == 'APPROVED') ? _c('button', {
    staticClass: "btn red m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.unpublish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar todas as fotos")])]) : _vm._e(), _vm._v(" "), (_vm.album.status != 'APPROVED') ? _c('button', {
    staticClass: "btn green-jungle m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.publish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar todas as fotos")])]) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-572a4149","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/gallery/album/album.vue
// module id = 1077
// module chunks = 1